import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// DEMO (kelola-group): language hardcoded to Indonesian. The browser language
// detector is intentionally dropped so the UI is always id-ID.
void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'id-ID',
    fallbackLng: 'id-ID',
    supportedLngs: ['id-ID'],
    ns: ['common'],
    defaultNS: 'common',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    interpolation: { escapeValue: false },
  });

export default i18n;
